import { V1_API_URL_PREFIX, ACCESS_TOKEN } from '../Constants';
import {request} from "./ApiUtils";
import {NotificationManager} from "react-notifications";

export function nonconformance() {
    return request({
        url: V1_API_URL_PREFIX + "/nonconformance",
        method: 'GET'
    });
}

export function nonconformanceRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/nonconformance/latestRevision",
        method: 'GET'
    });
}

export function saveOrUpdateNonconformance(nonconformanceRecord) {
    return request({
        url: V1_API_URL_PREFIX + "/nonconformance/update",
        method: 'POST',
        body: JSON.stringify(nonconformanceRecord)
    });
}

export function addNonconformanceRevision(nonconformanceRecord) {
    return request({
        url: V1_API_URL_PREFIX + "/nonconformance/add/revision",
        method: 'POST',
        body: JSON.stringify(nonconformanceRecord)
    });
}

export function deleteNonconformance(nonconformanceRecord) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/nonconformance/delete",
        method: 'DELETE',
        body: JSON.stringify(nonconformanceRecord)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function approve(nonconformanceRecord) {
    return request({
        url: V1_API_URL_PREFIX + "/nonconformance/changeStatus/APPROVED",
        method: 'POST',
        body: JSON.stringify(nonconformanceRecord)
    });
}

export function disapprove(nonconformanceRecord) {
    return request({
        url: V1_API_URL_PREFIX + "/nonconformance/changeStatus/NOT_APPROVED",
        method: 'POST',
        body: JSON.stringify(nonconformanceRecord)
    });
}

function checkFile(file) {
    //const fileInput = document.getElementById('fileInput');
    //const fileSize = fileInput.files[0].size;
    const fileSize = file.size;
    const maxSize = 10 * 1024 * 1024; // 10MB

    if (fileSize > maxSize) {
        // alert('File size must be less than 1MB');
        console.log('file check failed')
        NotificationManager.warning('Error', 'File size must be less than 10MB', 5000);
        return false;
    } else {
        console.log('file check passed')
        // Upload the file
        return true;
    }
}

export function uploadMultipleFiles(endPoint, id, files, callback) {
    let form = new FormData();
    form.append('id',  id);
    let filesValid = true;
    for (let i = 0; i < files.length; i++) {
        form.append('selectedFiles', files[i])
        if (!checkFile(files[i])) {
            filesValid = false;
            return;
        }
    }
    // form.append('selectedFile', new Blob([file]));
    let request = new XMLHttpRequest();
    request.open("POST", V1_API_URL_PREFIX + endPoint);
    if (localStorage.getItem(ACCESS_TOKEN)) {
        request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }
    request.send(form);
    request.onload = () => {
        callback(request.status, request.responseText);
    };
}

export function deleteFile(endPoint, id, fileId) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + endPoint + "/" + id + "/" + fileId,
        method: 'DELETE'
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}





export function incidentNotification() {
    return request({
        url: V1_API_URL_PREFIX + "/incidentNotification",
        method: 'GET'
    });
}

export function incidentNotificationRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/incidentNotification/latestRevision",
        method: 'GET'
    });
}

export function saveOrUpdateIncidentNotification(incidentNotification) {
    return request({
        url: V1_API_URL_PREFIX + "/incidentNotification/update",
        method: 'POST',
        body: JSON.stringify(incidentNotification)
    });
}

export function addIncidentNotificationRevision(incidentNotification) {
    return request({
        url: V1_API_URL_PREFIX + "/incidentNotification/add/revision",
        method: 'POST',
        body: JSON.stringify(incidentNotification)
    });
}

export function deleteIncidentNotification(incidentNotification) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/incidentNotification/delete",
        method: 'DELETE',
        body: JSON.stringify(incidentNotification)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function managementReview() {
    return request({
        url: V1_API_URL_PREFIX + "/management-review",
        method: 'GET'
    });
}

export function managementReviewDefaultAgendaItems() {
    return request({
        url: V1_API_URL_PREFIX + "/management-review/default-agenda-items",
        method: 'GET'
    });
}

export function managementReviewRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/management-review/latestRevision",
        method: 'GET'
    });
}

export function saveOrUpdateManagementReview(review) {
    console.log('updateing review', review);
    return request({
        url: V1_API_URL_PREFIX + "/management-review/update",
        method: 'POST',
        body: JSON.stringify(review)
    });
}

export function addManagementReviewRevision(review) {
    return request({
        url: V1_API_URL_PREFIX + "/management-review/add/revision",
        method: 'POST',
        body: JSON.stringify(review)
    });
}

export function deleteManagementReview(review) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/management-review/delete",
        method: 'DELETE',
        body: JSON.stringify(review)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}







export function emergencyResponseTesting() {
    return request({
        url: V1_API_URL_PREFIX + "/emergency-response-testing",
        method: 'GET'
    });
}

export function emergencyResponseTestingRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/emergency-response-testing/latestRevision",
        method: 'GET'
    });
}

export function saveOrUpdateEmergencyResponseTesting(review) {
    console.log('updateing emergency-response-testing', review);
    return request({
        url: V1_API_URL_PREFIX + "/emergency-response-testing/update",
        method: 'POST',
        body: JSON.stringify(review)
    });
}

export function addEmergencyResponseTestingRevision(review) {
    return request({
        url: V1_API_URL_PREFIX + "/emergency-response-testing/add/revision",
        method: 'POST',
        body: JSON.stringify(review)
    });
}

export function deleteEmergencyResponseTesting(review) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/emergency-response-testing/delete",
        method: 'DELETE',
        body: JSON.stringify(review)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function documentRetention() {
    return request({
        url: V1_API_URL_PREFIX + "/document-retention",
        method: 'GET'
    });
}

export function saveOrUpdateDocumentRetention(record) {
    return request({
        url: V1_API_URL_PREFIX + "/document-retention/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function deleteDocumentRetention(record) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/document-retention/delete",
        method: 'DELETE',
        body: JSON.stringify(record)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function documentRetentionRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/document-retention/latestRevision",
        method: 'GET'
    });
}

export function addDocumentRetentionRevision(review) {
    return request({
        url: V1_API_URL_PREFIX + "/document-retention/add/revision",
        method: 'POST',
        body: JSON.stringify(review)
    });
}

export function imsImprovementRegister() {
    return request({
        url: V1_API_URL_PREFIX + "/ims-improvement-register",
        method: 'GET'
    });
}

export function imsImprovementRegisterRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/ims-improvement-register/latestRevision",
        method: 'GET'
    });
}

export function saveOrUpdateImsImprovementRegister(review) {
    console.log('updateing ims-improvement-register', review);
    return request({
        url: V1_API_URL_PREFIX + "/ims-improvement-register/update",
        method: 'POST',
        body: JSON.stringify(review)
    });
}

export function addImsImprovementRegisterRevision(review) {
    return request({
        url: V1_API_URL_PREFIX + "/ims-improvement-register/add/revision",
        method: 'POST',
        body: JSON.stringify(review)
    });
}

export function deleteImsImprovementRegister(review) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/ims-improvement-register/delete",
        method: 'DELETE',
        body: JSON.stringify(review)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}